import { RegionType } from "@/type/index"
import KRDG from "@/region/KR-DG.json"
import US from "@/region/US.json"

export default {
    namespaced: true,

    state: {
        regionName: RegionType[408241936],
        regions: KRDG
    },
    getters: {},
    mutations: {
        setRegions(state, value) {
            state.regionName = value
            switch (value) {
                case "US": {
                    state.regions = US
                    break
                }
                case "KRDG": {
                    state.regions = KRDG
                    break
                }
                default: {
                    state.regions = KRDG
                }
            }
        }
    },
    actions: {},
    modules: {}
}